import React, { useContext, useEffect, useState } from "react";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { Typography, Tooltip } from "@mui/material";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import { useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/Network/APICalls";
import {
  DownloadSanjeevaniApplicationForm,
  DownloadSuvidhaApplicationForm,
  GetSettlementrequestDetails,
  DownloadSettlementApplicationForm,
  DownloadSettlementApplicationFormAfterApprovel,
  getRePaymentHistory,
} from "../../../Helpers/APIEndPoints/EndPoints";
import OverflowTip from "../../../Components/OverflowToolTip/OverflowToolTip";
import moment from "moment";
import { DATE_DISPLAY_FORMAT } from "../../../Helpers/Constants/Constants";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import { useDispatch } from "react-redux";
import { setIsLoanParams } from "../../../Redux/Actions/LoanModuleAction";
import Modal from "react-modal";
import { ISettlementReqGrid } from "./ISettlementReqGrid";
import axios from "axios";
import fileDownload from "js-file-download";
import { AppModules } from "../../../Helpers/Enums/AppModules";
import { fetchAuthToken } from "../../../Helpers/Network/OAuthHandler";
import { MODES } from "../../../Helpers/Enums/Enum";
import { getActionEditSettlement, getStatusIds } from "../Helpers/GridHelper";
import { SettlementReqStatus } from "../../../Helpers/Enums/ApplicationStatus";


// import { IStatmentReqGrid } from "./IStatmentReqGrid";
Modal.setAppElement("#root"); // Set the root element for accessibility

const SettlementReqGrid = (props: ISettlementReqGrid) => {
  const {
    searchText,
    setSearchText,
    activeTab,
    currentFilters,
    dataCount,
    setDataCount,
    setCurrentDataReqObj,
  } = props;
  const context = getContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { showLoader, hideLoader } = useContext(LoaderContext);

  const [sortDirection, setSortDirection] = useState("");
  const [pageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [dashboardData, setDashboardData] = useState([]);

  // const [historyStart, setHistoryStart] = useState(0);
  // const [historyPageSize] = useState(10);
  // const [historySortDirection, setHistorySortDirection] = useState("");
  // const [historySortColumn, setHistorySortColumn] = useState("");
  // const [historyCount, setHistoryCount] = useState(0);
  // const [dashboardHistoryData, setDashboardHistoryData] = useState([]);
  // const [modalIsOpen, setModalIsOpen] = useState(false);
  const [Process, setProcess] = useState("Document Is Under Process Please Wait...");
  useEffect(() => {
    dispatch(setIsLoanParams({ LoanId: 0, MemberId: 0 }));
  }, []);

  const getDashboardData = async () => {
    showLoader();
    try {
      let statusIds;
      setCurrentDataReqObj(null);

      let statusIdArr = getStatusIds(
        activeTab.module,
        context.loggedInAs.value as RoleEnum
      );
      statusIds =
        currentFilters?.status?.value?.toString() || statusIdArr.join(",");


      let unitCodeIds = "";
      if (context?.CurrentRoleId === RoleEnum.InternalTeam) {
        unitCodeIds = context?.UnitCodeIds;
      }
      const filterUnitCodeIds = currentFilters?.unitCode?.map((v) => v?.value);
      if (filterUnitCodeIds?.length > 0) {
        unitCodeIds = filterUnitCodeIds?.join(",");
      }

      let obj = {
        start: start,
        resultsPerPage: pageSize, //Done
        searchText: searchText, //Done
        sortColumn: sortColumn, //Done
        sortDirection: sortDirection, //Done
        UnitCode: unitCodeIds, //Done
        MemberId:
          (context?.loggedInAs?.value as RoleEnum) === RoleEnum.Member
            ? context?.MemberId
            : 0,
        TypeOfApplicants:
          currentFilters?.typeofApplicant?.map((v) => v?.value)?.join(",") ||
          "", //Done
        FromDate: currentFilters?.fromDate || "", //Done
        ToDate: currentFilters?.toDate || "", //Done
        Status: statusIds, //Done
        SettlementRoleId: context?.loggedInAs?.value,
      };
    
        
      setCurrentDataReqObj(obj);
      // const resp = await APICall(GetSettlementrequestDetails, obj);

      // if (resp?.Data.SettlementPendingRequest.length > 0) {
      //   setDashboardData(resp?.Data.SettlementAllrequest);
      // } else {
      //   setDashboardData([]);
      // }
      // const dataCount = resp?.Data[0]?.TotalCount || resp?.Data?.length || 0;
      // setDataCount(dataCount);
      // if (activeTab.id === "All-requests") {
        const resp = await APICall(GetSettlementrequestDetails, obj);
        if (resp.Data.SettlementAllrequest.length > 0) {
          
          setDashboardData(resp?.Data.SettlementAllrequest);
          const dataCount = resp?.Data?.SettlementAllrequest[0].TotalCount;
          setDataCount(dataCount ?? 0);
          hideLoader();
        } else {
          setDashboardData([]);
          setDataCount(0);
        }
      // } else if (activeTab.id === "Pending") {
      //   // SettlementPendingRequest
      //   const resp = await APICall(GetSettlementrequestDetails, obj);
      //   if (resp.Data.SettlementPendingRequest.length > 0) {
      //     setDashboardData(resp?.Data.SettlementPendingRequest);
      //     const dataCount = resp?.Data?.SettlementPendingRequest[0].TotalCount;
      //     setDataCount(dataCount ?? 0);
      //     hideLoader();
      //   } else {
      //     setDashboardData([]);
      //     setDataCount(0);
      //   }
      // }
    } catch (err) {
      notify(
        ToastType.Error,
        "Oops! Something went wrong. We're on it. Please try again later."
      );
      // console.log("There is no data");
    } finally {
      hideLoader();
    }
  };

  const downloadDynForm = async (MemberIdFromList, recordId) => {
    showLoader();
    let requestParams = {
      MemberId: MemberIdFromList,
      Id: recordId,
    };
    let token = await fetchAuthToken();
    let fileNamePrefix = "";
    let urlPrefix = "";
    if (activeTab.id === "All-requests") {
      fileNamePrefix = "Settlement Request_";
      urlPrefix = DownloadSettlementApplicationForm;
    } else if (activeTab.id === "Pending") {
      fileNamePrefix = "Settlement Request_";
      urlPrefix = DownloadSettlementApplicationForm;
    }
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: urlPrefix,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        fileDownload(
          response.data,
          `${fileNamePrefix}${moment(new Date()).format(
            moment.HTML5_FMT.DATE
          )}.pdf`
        );

        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        notify(
          1,
          "Oops! Something went wrong. We're on it. Please try again later."
        );
      
      });
  };

  const downloadDynFormAfterAproval = async (MemberIdFromList, recordId) => {
    showLoader();
    let requestParams = {
      MemberId: MemberIdFromList,
      Id: recordId,
    };
    let token = await fetchAuthToken();
    let fileNamePrefix = "";
    let urlPrefix = "";
    if (activeTab.id === "All-requests") {
      fileNamePrefix = "Fi Document_";
      urlPrefix = DownloadSettlementApplicationFormAfterApprovel;
    } 
    // else if (activeTab.id === "Pending") {
    //   fileNamePrefix = "Fi Document_";
    //   urlPrefix = DownloadSettlementApplicationFormAfterApprovel;
    // }
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: urlPrefix,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        fileDownload(
          response.data,
          `${fileNamePrefix}${moment(new Date()).format(
            moment.HTML5_FMT.DATE
          )}.pdf`
        );

        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        notify(
          1,
          "Oops! Something went wrong. We're on it. Please try again later."
        );
      
      });
  };

  const DownloadFunction = async (MemberIdFromList, recordId) => {
    showLoader();
    let requestParams = {
      MemberId: MemberIdFromList,
      Id: recordId,
    };
    let token = await fetchAuthToken();
    let urlPrefix = "";
    if (activeTab.id === "All-requests") {
      
      urlPrefix = DownloadSettlementApplicationFormAfterApprovel;
    } 
    // else if (activeTab.id === "Pending") {
      
    //   urlPrefix = DownloadSettlementApplicationFormAfterApprovel;
    // }
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: urlPrefix,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setProcess("Please Check Document Downloaded Successfully")
        fileDownload(
          response.data,
          `Documents_` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.pdf`
        );

      })
      .catch((error) => {
        setProcess("Please Retry")
        notify(ToastType.Error, error);
      
      })
      .finally(() => {
        hideLoader(); 
    });
  };

  const CustomCellComponent = (
    value: any,
    tableMeta: any,
    isDate: boolean = false
  ) => {
    return (
      <>
        <OverflowTip>
          <Typography
            fontFamily={"Georama-Regular"}
            fontSize={"14px"}
            component={"span"}
            noWrap={true}
          >
            {!isDate
              ? value
              : value
              ? moment(value).format(DATE_DISPLAY_FORMAT)
              : ""}
          </Typography>
        </OverflowTip>
      </>
    );
  };

  const CommonCellOptions = (isDate: boolean = false) => {
    return {
      filter: true,
      sort: true,
      sortDescFirst: true,
      customBodyRender: (value, tableMeta) =>
        CustomCellComponent(value, tableMeta, isDate),
    };
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const GridColumns = [
    //0
    {
      name: "MemberNumber",
      label: "Member No",
      options: CommonCellOptions(),
    },
    //1
    {
      name: "Name",
      label: "Name",
      options: {
        ...CommonCellOptions(),
        display: true,
      },
    },
    //2
    {
      name: "DateOfConfirmation",
      label: "Date of Confirmation",
      options: {
        ...CommonCellOptions(true),
        display: activeTab.id === "Pending",
      },
    },
    //3
    {
      name: "ApplicationDate",
      label: "Application Date",
      options: {
        ...CommonCellOptions(true),
        display: true,
      },
    },
    //4
    {
      name: "Evoluator",
      label: "Evaluator",
      options: {
        ...CommonCellOptions(false),
        display: true // activeTab.id === "All-requests",
      },
    },
    //5
    {
      name: "Duration",
      label: "Duration",
      options: {
        ...CommonCellOptions(),
        display: false, // activeTab.id === "All-requests",
      },
    },
    //6
    {
      name: "Status",
      label: "Status",
      options: {
        display: true,
      },
    },
    // 7
    {
      name: "StatusId",
      label: "StatusId",
      options: {
        display: false,
      },
    },

    //8
    {
      name: "Action",
      label: "Action",
      options: {
        // display: activeTab.id === "All-requests",
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          const currentStatus = tableMeta.rowData[7];
          const MemberIdFromList = tableMeta.rowData[10];
          const recordId = tableMeta.rowData[11];
          let shouldShowEdit = false;
          let shouldShowView = false;

          let statusIdArr = getActionEditSettlement(context?.CurrentRoleId);
          shouldShowEdit = statusIdArr.includes(currentStatus);
          shouldShowView = !shouldShowEdit;

          if (
            shouldShowEdit &&
            context?.CurrentRoleId === RoleEnum.InternalTeam
          ) {
            // Settlement_Approval_Pending -> internal team (Edit only) -> SettlementRequestTabs
            // Settlement_Approval_Pending -> member (view only) -> FinalSettlement
            // Settlement_Approved  member (view only)  FinalSettlement
            // Settlement_Rejected  member (view only) FinalSettlement
            // Settlement_Approved  internal team(view only) SettlementRequestTabs
            // Settlement_Rejected  internal team(view only) SettlementRequestTabs
            
            const path = "/SettlementRequestTabs";
            return (
              <>
                <div className="d-flex justify-content-start align-items-center">
                  <Tooltip title="Edit">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        e.preventDefault();

                        if (context?.CurrentRoleId === RoleEnum.InternalTeam) {
                          navigate(path, {
                            state: {
                              currentStatus: currentStatus,
                              SetId: recordId,
                              MemberId: MemberIdFromList,
                              mode: MODES.EDIT,
                            },
                          });
                        }
                      }}
                    >
                      <i className="fas fa-edit"></i>
                    </a>
                  </Tooltip>
                </div>
              </>
            );
          } else {
            let path = "";
            let VisiableViewEdit =
              [SettlementReqStatus.Settlement_Rejected].includes(
                currentStatus
              ) &&
              (context?.CurrentRoleId === RoleEnum.Member ||
                context?.CurrentRoleId === RoleEnum.InternalTeam)
                ? true
                : false;
            if (
              [
                SettlementReqStatus.Settlement_Approved,
                SettlementReqStatus.Settlement_Approved2,
                SettlementReqStatus.Settlement_Rejected,
              ].includes(currentStatus) &&
              context?.CurrentRoleId === RoleEnum.InternalTeam
            ) {
              path = "/SettlementRequestTabs";
            } else if (
              [
                SettlementReqStatus.Settlement_Approved,
                SettlementReqStatus.Settlement_Approved2,
                SettlementReqStatus.Settlement_Rejected,
                SettlementReqStatus.Settlement_Approval_Pending,
                SettlementReqStatus.Settlement_Data_Pending
              ].includes(currentStatus) &&
              context?.CurrentRoleId === RoleEnum.Member || context?.CurrentRoleId === RoleEnum.InternalTeam
            ) {
              path = "/FinalSettlement";
            }

            return (
              <>
                <div className="d-flex justify-content-right align-items-center">
                  <Tooltip title="view">
                    <a
                      className="pr-3"
                      onClick={(e) => {
                        e.preventDefault();
                        if (
                          context?.CurrentRoleId === RoleEnum.InternalTeam ||
                          RoleEnum.Member
                        ) {
                          navigate(path, {
                            state: {
                              currentStatus: currentStatus,
                              SetId: recordId,
                              MemberId: MemberIdFromList,
                              mode: MODES.VIEW,
                              // mode: VisiableViewEdit ? MODES.EDIT : MODES.VIEW,
                            },
                          });
                        }
                      }}
                    >
                      {/* {VisiableViewEdit ? (
                        <i className="fas fa-edit"></i>
                      ) : ( */}
                      <i className="fas fa-eye"></i>
                      {/* )} */}
                    </a>
                  </Tooltip>
                  {!VisiableViewEdit && (
                    <Tooltip title="Application Form" className="ml-3">
                      <a
                        onClick={() =>
                          downloadDynForm(MemberIdFromList, recordId)
                        }
                      >
                        <i className="far fa-file-archive"></i>
                      </a>
                    </Tooltip>
                  )}
                 {!VisiableViewEdit && SettlementReqStatus.Settlement_Approved.toString() === "Settlement_Approved" && (
                    <Tooltip title="FI Document" className="ml-3">
                      <a
                        onClick={() => downloadDynFormAfterAproval(MemberIdFromList, recordId)}
                      >
                        <i className="far fa-file-archive"></i>
                      </a>
                    </Tooltip>
                  )}
                  {/* {!VisiableViewEdit && (
                    <Tooltip title="FI Document" className="ml-3">
                      <a
                        onClick={() => downloadDynFormAfterAproval(MemberIdFromList, recordId)}
                      >
                        <i className="far fa-file-archive"></i>
                      </a>
                    </Tooltip>
                  )} */}
                </div>
              </>
            );
          }
        },
      },
    },
    //9
    {
      name: "Action",
      label: "Action",
      options: {
        display: false, //activeTab.id === "Pending",
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          const currentStatus = tableMeta.rowData[7];
          const MemberIdFromList = tableMeta.rowData[10];
          const recordId = tableMeta.rowData[11];
          const path = "/Profile";
          let shouldShowEdit = false;
          let shouldShowView = false;

          let statusIdArr = getActionEditSettlement(context?.CurrentRoleId);
          shouldShowEdit = statusIdArr.includes(currentStatus);
          shouldShowView = !shouldShowEdit;

          if (
            [
              SettlementReqStatus.Settlement_Approval_Pending,
              SettlementReqStatus.Settlement_Approved,
            ].includes(currentStatus)
          ) {
            return (
              <>
                <div className="d-flex justify-content-start align-items-center">
                  <Tooltip title="Edit">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={(e) => {
                        e.preventDefault();

                        if (
                          context?.CurrentRoleId === RoleEnum.InternalTeam ||
                          RoleEnum.Member
                        ) {
                          navigate(path, {
                            // state: {
                            //   currentStatus: currentStatus,
                            // },
                            state: {
                              currentStatus: currentStatus,
                              SetId: recordId,
                              MemberId: MemberIdFromList,
                              mode: MODES.EDIT,
                            },
                          });
                        }
                      }}
                    >
                      <i className="fas fa-edit"></i>
                    </a>
                  </Tooltip>
                </div>
              </>
            );
          } else {
            return (
              <Tooltip title="view">
                <a
                  className="pr-3"
                  onClick={(e) => {
                    e.preventDefault();
                    if (
                      context?.CurrentRoleId === RoleEnum.InternalTeam ||
                      RoleEnum.Member
                    ) {
                      navigate(path, {
                        state: {
                          currentStatus: currentStatus,
                          SetId: recordId,
                          MemberId: MemberIdFromList,
                          mode: MODES.VIEW,
                        },
                      });
                    }
                  }}
                >
                  <i className="fas fa-eye"></i>
                </a>
              </Tooltip>
            );
          }
        },
      },
    },
    //10
    {
      name: "MemberId",
      label: "MemberId",
      options: {
        display: false,
      },
    },
    //11
    {
      name: "SetId",
      label: "SetId",
      options: {
        display: false,
      },
    },
  ];

  useEffect(() => {
    if (activeTab != null) {
      getDashboardData();
    }
  }, [activeTab, start, sortColumn, sortDirection, searchText, currentFilters]);

  return (
    <div>
      <DynamicGrid
        options={Options}
        data={dashboardData}
        columns={GridColumns}
      />
    </div>
  );
};

export default SettlementReqGrid;
